export const RECORD_COMPANY = 'CU';
export const RECORD_CONTACT = 'CO';
export const RECORD_LEAD = 'LD';
export const RECORD_DEAL = 'DL';
export const RECORD_CASE = 'CS';
export const RECORD_EMAIL = 'EM';
export const RECORD_CALL = 'CA';
export const RECORD_MEETING = 'ME';
export const RECORD_TASK = 'TA';
export const RECORD_CAMPAIGN = 'CM';
export const RECORD_FILE = 'FL';
export const RECORD_CHAT = 'CT';
export const RECORD_USER = 'UR';
export const RECORD_TEAM = 'TE';
export const RECORD_SUB_TEAM = 'ST';
export const RECORD_TEAM_ASSIGNMENT = 'TA';




// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/constants.model.ts